module.exports = __webpack_public_path__ + "b15fe977a2ae623005b45a1337f8ed57.svg";